Customer.Users ||= {}

class Customer.Users.ProfileModerationChartView extends Backbone.View
  template: JST["backbone/templates/customer/users/profile_moderation_chart"]

  className: 'main-profile-section main-profile-moderation-chart'

  initialize: (@options = {}) ->
    @searchQuery = @options.search_query

  render: ->
    @$el.html(@template())
    @_renderModerationBarChart()
    return this

  _renderModerationBarChart: ->
    @_renderChart(new Monitoring.Views.Charts.CustomProfileModerationChart({
      searchQuery: @searchQuery
      responsePostProcessor: @responsePostProcessor
      settings:
        title: ''
        maximized: false
    }))

  _renderChart: (chart) ->
    chart.appendChart(@$el.find('.chart-container'))
    chart.$el.find('#close_chart').addClass('hidden')

  responsePostProcessor: (response) ->
    result = { series: [] }
    # example of a response to be converted to the needed format:
    # [
    #   {
    #       count: 5
    #       term: "REJECTED"
    #   },
    #   {
    #       count: 4
    #       term: "APPROVED"
    #   },
    #   {
    #       count: 20
    #       term: "Manual moderation"
    #   }
    # ] # we will assume the order is not always the same
    #
    # this example must be converted to the following:
    # {
    #   series: [
    #     {
    #       name: 'Automatically Approved'
    #       data: [4]
    #       color: '#3EA99F'
    #     },
    #     {
    #       name: 'Manual'
    #       data: [20]
    #       color: '#E78A61'
    #     },
    #     {
    #       name: 'Automatically Rejected'
    #       data: [5]
    #       color: '#C24641'
    #     }
    #   ]
    # }
    mapping = {
      REJECTED: {
        name: 'Automatically Rejected'
        color: '#C24641' # Cherry Red
      }
      APPROVED: {
        name: 'Automatically Approved'
        color: '#3EA99F' # Light Sea Green
      }
      Manual: {
        name: 'Manual'
        color: '#E78A61' # Tangerine
      }
    }
    validResponse = _.filter(response, (moderationGroup) -> moderationGroup.hasOwnProperty('term') && moderationGroup.term != undefined )
    result.series = _.map(validResponse, (moderationGroup) ->
      group = mapping[moderationGroup.term.split(" ")[0]]
      group.data = [moderationGroup.count]
      group
      )
    result
